import { useMutation } from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.enterprises.batchCreateServiceAccounts;

type RequestPayload = Parameters<
  typeof apiFn
>[0]['batchCreateEnterpriseServiceAccountsRequest'];

export const useBatchCreateEnterpriseServiceAccountsMutation = (
  enterpriseId: string
) => {
  return useMutation({
    mutationFn: (payload: RequestPayload) =>
      apiFn(
        {
          enterpriseId,
          batchCreateEnterpriseServiceAccountsRequest: payload,
        },
        {
          headers: overrideOrganizationHeader(enterpriseId),
        }
      ),
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
